import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';

import { MONTH_NAMES } from './utils/PreventiveTaskProjectionCalendarUtils';

const PreventiveTaskProjectionHeader = ({
  year,
  month,
  daysToAdd,
  onPreviousMonth,
  onNextMonth,
}) => (
  <Card className="mb-3">
    <CardBody>
      <Row className="align-items-center">
        <Col md="3">
          <strong>Corte operativo:</strong>{' '}
          {daysToAdd ? `Hoy + ${daysToAdd} día(s)` : 'Hoy'}
        </Col>

        <Col md="6" className="text-center">
          <Button color="light" onClick={onPreviousMonth}>
            ‹
          </Button>

          <span className="mx-4 h4">
            {MONTH_NAMES[month]} {year}
          </span>

          <Button color="light" onClick={onNextMonth}>
            ›
          </Button>
        </Col>
      </Row>
    </CardBody>
  </Card>
);

PreventiveTaskProjectionHeader.propTypes = {
  year: PropTypes.number.isRequired,
  month: PropTypes.number.isRequired,
  daysToAdd: PropTypes.number,
  onPreviousMonth: PropTypes.func.isRequired,
  onNextMonth: PropTypes.func.isRequired,
};

PreventiveTaskProjectionHeader.defaultProps = {
  daysToAdd: 0,
};

export default PreventiveTaskProjectionHeader;
